<template>
  <Submenu :name="parentItem.menuId">
    <template slot="title">
      <Icon :type="parentItem.menuIcon" />
      <span>{{ parentItem.menuName }}</span>
    </template>
    <div v-for="item in parentItem.children" :key="item.menuId">
      <left-menu-item v-if="item.children && item.children.length!==0" :parent-item="item"></left-menu-item>
      <menu-item v-else :to="item.menuRoute" :name="item.menuId">
        <Icon :type="item.menuIcon" />
        <span>{{ item.menuName }}</span>
      </menu-item>
    </div>
  </Submenu>
</template>
 
<script>
export default {
  name: 'left-menu-item',
  props: {
    parentItem: {
      type: Object,
      default: () => { }
    }
  }
}
</script>